import { RetryFailedPspNotificationsDto } from '../../../../generated-api'

import { apiClient } from 'api'
import { parseError } from 'utils/error-handler'

export const retryFailedPspNotifications = async (
    retryFailedPspNotificationsDto: RetryFailedPspNotificationsDto,
    token: string
) =>
    await apiClient.PaymentOperationsOverviewApi.retryFailedPspNotifications(
        { retryFailedPspNotificationsDto },
        {
            headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        }
    ).catch(parseError)

export const retryNonCapturedPayments = async (paymentIds: number[], token: string) =>
    await apiClient.PaymentOperationsOverviewApi.retryNonCapturedPayments(
        { retryNonCapturedPaymentsDto: { paymentIds } },
        {
            headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        }
    ).catch(parseError)

export const retryUnknownStatePayments = async (paymentIds: number[], token: string) =>
    await apiClient.PaymentOperationsOverviewApi.retryUnknownStatePayments(
        { retryUnknownStatePaymentsDto: { paymentIds } },
        {
            headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        }
    ).catch(parseError)

export const excludeNonCapturedPaymentsFromWashing = async (paymentIds: number[], token: string) =>
    await apiClient.PaymentOperationsOverviewApi.excludeNonCapturedPaymentsFromWashing(
        { requestBody: paymentIds },
        {
            headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        }
    ).catch(parseError)
